import React from 'react';
import { MessageCircle } from 'lucide-react';

export default function FeedbackButton() {
  const handleFeedback = () => {
    window.location.href = 'mailto:support@teachermaterial.app?subject=Teacher Material Feedback&body=Hi! I wanted to share some feedback about Teacher Material:%0D%0A%0D%0A';
  };

  return (
    <button
      onClick={handleFeedback}
      style={{
        position: 'fixed',
        bottom: '24px',
        right: '24px',
        background: 'linear-gradient(135deg, #66bb6a 0%, #42a5f5 100%)',
        color: 'white',
        border: 'none',
        borderRadius: '50px',
        padding: '16px 24px',
        fontSize: '16px',
        fontWeight: '600',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        boxShadow: '0 4px 20px rgba(102, 187, 106, 0.4)',
        transition: 'all 0.3s',
        zIndex: 1000
      }}
      onMouseOver={(e) => {
        e.currentTarget.style.transform = 'translateY(-4px) scale(1.05)';
        e.currentTarget.style.boxShadow = '0 6px 30px rgba(102, 187, 106, 0.6)';
      }}
      onMouseOut={(e) => {
        e.currentTarget.style.transform = 'translateY(0) scale(1)';
        e.currentTarget.style.boxShadow = '0 4px 20px rgba(102, 187, 106, 0.4)';
      }}
    >
      <MessageCircle size={20} />
      Send Feedback
    </button>
  );
}